const TRACKED_FIELDS = [
  'sales',
  'customers',
  'purchases',
  'lots',
  'products',
  'suppliers',
  'stockData',
  'invoices',
  'orders',
  'expenses',
  'invoicePayments',
  'supplierDebts',
  'customerDebts',
  'customerInvoices',
  'supermarketPayments',
  'supermarketInvoices',
  'expiredProducts',
  'notifications',
  'workerSessions',
  'reports',
  'discrepancyManagement',
  'stockLocations',
  'persistentStockData',
  'offlineQueue',
  'businessInfo',
  'userInfo',
  'metadata',
  'stockMovements'
];

/**
 * Cheap inequality before JSON.stringify — merges usually keep unchanged
 * field references, so most tracked fields exit here (PERF-03).
 * @param {unknown} a
 * @param {unknown} b
 */
function fieldLikelyChanged(a, b) {
  if (a === b) return false;
  if (a == null || b == null) return a !== b;
  if (Array.isArray(a) && Array.isArray(b) && a.length !== b.length) return true;
  return true;
}

/**
 * Welche Top-Level-Felder im merged business_*_data Blob sich geändert haben.
 * @param {object} before
 * @param {object} after
 * @returns {string[]}
 */
export function detectPayloadFieldChanges(before, after) {
  const changed = [];
  for (const field of TRACKED_FIELDS) {
    const prev = before?.[field];
    const next = after?.[field];
    if (!fieldLikelyChanged(prev, next)) continue;
    try {
      if (JSON.stringify(prev) !== JSON.stringify(next)) {
        changed.push(field);
      }
    } catch {
      changed.push(field);
    }
  }
  return changed;
}
